import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import MainContext from '../../Components/Contexts/MainContext';
import { useTranslation } from "react-i18next";
import { usePortal } from '../Contexts/PortalContext';
import { isStaffGroupInfo } from '../../services/firmaSessionService';
// WAS (until #704): import { yabanciKatilimciMi } from '../Kisi/YabanciKatilimciParcalari';
import { sadePanelMi } from '../../services/sadePanel';

const getInitials = (firstName, lastName) => {
    if (!firstName || !lastName) return "A";
    return `${firstName[0]}${lastName[0]}`;
};

const ProfileDropdown = () => {
  const { t } = useTranslation("components");
    // #418: a company login shows its portal role(s) under its name (the legacy user_group name is the account type, not
    // what it may do) and where to ask for another one: no self-service, SAKA staff assign roles (#409 D4).
    const portal = usePortal();
    const rolMetni = portal?.kullaniciRolleri?.length ? portal.kullaniciRolleri.map((r) => r.ad).join(', ') : null;
    const [Name, setName] = useState(null);
    const [userName, setUserName] = useState(null);
    const [initials, setInitials] = useState(null);
    const [userGroupName, setUserGroupName] = useState(null);
    const navigate = useNavigate();

    const { getUserDataContext } = useContext(MainContext);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const { userInfo, groupInfo } = await getUserDataContext();
                setUserName(`${userInfo.userName} ${userInfo.userSurname}`);
                setName(userInfo.userName);
                setInitials(getInitials(userInfo.userName, userInfo.userSurname));
                setUserGroupName(groupInfo.userGroupName);
            } catch (error) {
                console.error('Error fetching user info:', error);
            }
        };

        fetchUserData();
    }, [getUserDataContext]);

    // #574: the staff-only link to the member's own mail accounts (company logins never see it; the page refuses them too)
    const staff = (() => {
        try { return isStaffGroupInfo(JSON.parse(localStorage.getItem('groupInfo'))); } catch { return false; }
    })();

    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleLogout = () => {
        localStorage.removeItem('userId');
        localStorage.removeItem('token');
        localStorage.removeItem('groupInfo');
        localStorage.removeItem('user');
        navigate('/login');
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <div className="rounded-circle header-profile-user d-flex align-items-center justify-content-center bg-primary text-white" style={{ width: 40, height: 40, fontSize: 20 }}>
                            {initials}
                        </div>
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            {/* WAS (until #418): {userGroupName} only */}
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{rolMetni ?? userGroupName}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">{t("profilMenusu.hosgeldin")}{" "}{Name}</h6>
                    {/* #607: Yabancı Katılımcı sees the Mobile App entry but cannot use it (WAS: always a link to /installPWA). */}
                    {/* #704: so does every company login while Sade panel modu is ON. WAS (until #704): {yabanciKatilimciMi(portal) ? ( */}
                    {sadePanelMi(portal) ? (
                        <DropdownItem className='p-0' disabled data-testid="mobil-uygulama-pasif">
                            <span className="dropdown-item disabled" aria-disabled="true">
                                <i className="bx bxl-play-store text-muted fs-16 align-middle me-1"></i>
                                <span className="align-middle">{t("profilMenusu.mobilUygulama")}</span>
                            </span>
                        </DropdownItem>
                    ) : (
                        <DropdownItem className='p-0'>
                            <Link to="/installPWA" className="dropdown-item">
                                <i className="bx bxl-play-store text-muted fs-16 align-middle me-1"></i>
                                <span className="align-middle">{t("profilMenusu.mobilUygulama")}</span>
                            </Link>
                        </DropdownItem>
                    )}
                    <DropdownItem className='p-0'>
                        <Link to="/profile" className="dropdown-item">
                            <i className="bx bx-user text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">{t("profilMenusu.profil")}</span>
                        </Link>
                    </DropdownItem>
                    {/* #640: the user's own two-step verification (SMS / authenticator), for staff and company logins alike */}
                    <DropdownItem className='p-0'>
                        <Link to="/profile/guvenlik" className="dropdown-item">
                            <i className="bx bx-shield-quarter text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">{t("profilMenusu.guvenlik")}</span>
                        </Link>
                    </DropdownItem>
                    {staff && (
                        <DropdownItem className='p-0'>
                            <Link to="/EmailHesaplarim" className="dropdown-item">
                                <i className="bx bx-envelope text-muted fs-16 align-middle me-1"></i>
                                <span className="align-middle">{t("profilMenusu.epostaHesaplarim")}</span>
                            </Link>
                        </DropdownItem>
                    )}
                    {portal?.kullaniciRolleri?.length > 0 && !portal.onizleme && (
                        <div className="px-3 py-1 small text-muted" data-testid="rol-degistir-notu">
                            <i className="bx bx-info-circle align-middle me-1"></i>
                            {t("profilMenusu.rolDegistirmekIcin")}
                        </div>
                    )}
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0' onClick={handleLogout}>
                        <Link to="/pages-profile-settings" className="dropdown-item">
                            <i className="bx bx-exit text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">{t("profilMenusu.cikisYap")}</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
